// El nombre del cliente TAL COMO SE MUESTRA (G9, recorrido DEV 17-oct): HubSpot entrega algunos nombres con las
// comillas del CSV pegadas («"INMOTION S.R.L."»). Se limpian AL MOSTRAR (lista, buscador, cabecera); el dato
// guardado no se toca.
//
// ESPEJO de `backend/src/shared/pricer-datec-nombre-cliente.ts` (que limpia el documento y el Excel): un test
// compara los dos con los mismos casos. Si cambia uno, cambia el otro.

/** Comillas dobles: rectas y tipográficas. Las simples no (D'Agostino, O'Hara). */
const ES_COMILLA = /["“”«»]/;
const COMILLAS = /["“”«»]/g;

/**
 * «"INMOTION S.R.L."» → «INMOTION S.R.L.»; «"ACME ""Norte"""» → «ACME "Norte"»; «INMOTION S.R.L."» → «INMOTION
 * S.R.L.». Saca las comillas dobles que ENVUELVEN el nombre, deshace el escape de CSV (`""` → `"`) y quita una
 * comilla suelta en un borde. Unas comillas de adentro («ACME "Norte"») quedan.
 */
export function nombreDeClienteParaMostrar(nombre: string | null | undefined): string {
  if (!nombre) return '';
  let limpio = nombre.trim();
  for (let i = 0; i < 3 && limpio.length >= 2; i += 1) {
    if (!ES_COMILLA.test(limpio[0]!) || !ES_COMILLA.test(limpio[limpio.length - 1]!)) break;
    limpio = limpio.slice(1, -1).trim();
  }
  limpio = limpio.replace(/""/g, '"');
  if ((limpio.match(COMILLAS) ?? []).length === 1) {
    if (ES_COMILLA.test(limpio[0] ?? '')) limpio = limpio.slice(1).trim();
    else if (ES_COMILLA.test(limpio[limpio.length - 1] ?? '')) limpio = limpio.slice(0, -1).trim();
  }
  return limpio;
}
